module.exports = [{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/budget/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-MXQVJQ7","includeInDevelopment":false},
    },{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/budget/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/budget/budgets/summary/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
